import { useTheme } from '@mui/material';
import { SVGProps } from 'react';

export const BackIcon = (props: SVGProps<SVGSVGElement>) => {
  const theme = useTheme();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      fill="none"
      {...props}
    >
      <path
        stroke={theme.palette.action.active}
        strokeLinecap="round"
        strokeWidth={1.5}
        d="m10.2 5.4-6.246 6.246a.5.5 0 0 0 0 .707L10.2 18.6M20.4 12H4"
      />
    </svg>
  );
};
